import React, { useState } from "react";
import { DatePicker, Button, Card, Divider, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import AdminDashboard from "../Layout/AdminDashboard";
import AuditExport from "./AuditExport";

const { RangePicker } = DatePicker;

const SummaryReports = () => {
  const [dateRange, setDateRange] = useState(null);
  // const [previewData, setPreviewData] = useState([]);
  // const [previewHeaders, setPreviewHeaders] = useState([]);

  const [sheetData, setSheetData] = useState({});


  const apiUrl = process.env.REACT_APP_API_URL;

  // Sample summary data - replace with your actual data in production
  const summaryItems = [{ id: 1, title: "Summary " }];

  const handleDateChange = (dates) => {
    setDateRange(dates);
    console.log("Selected date range:", dates);
  };

  const generateAndDownload = async (summaryId) => {
    if (!dateRange || dateRange.length !== 2) {
      message.warning("Please select a date range first.");
      return;
    }

    const startDate = dateRange[0].format("YYYY-MM-DD");
    const endDate = dateRange[1].format("YYYY-MM-DD");
    console.log("Generating report for:", startDate, endDate);
    try {
      const response = await fetch(
        `${apiUrl}/api/summary/generateProposalExcel?startDate=${startDate}&endDate=${endDate}`
      );
      console.log(response, "summary DOWNLOAD get data");
      if (!response.ok) {
        throw new Error("Failed to generate Excel file");
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Summary_Report_${summaryId}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      message.success("Excel sheet downloaded successfully");
    } catch (error) {
      message.error("Failed to download Excel sheet");
    }
  };


  // view the summary

  const generateAndView = async () => {
    if (!dateRange || dateRange.length !== 2) {
      message.warning("Please select a date range first.");
      return;
    }

    const startDate = dateRange[0].format("YYYY-MM-DD");
    const endDate = dateRange[1].format("YYYY-MM-DD");

    try {
      const response = await fetch(
        `${apiUrl}/api/summary/generateProposalExcel?startDate=${startDate}&endDate=${endDate}`
      );
      console.log(response, "summary VIEWS get data");
      if (!response.ok) {
        throw new Error("Failed to generate Excel file");
      }

      const blob = await response.blob();
      const arrayBuffer = await blob.arrayBuffer();

      const workbook = XLSX.read(arrayBuffer, { type: "array" });

      const allSheets = {};

      workbook.SheetNames.forEach((sheetName) => {
        const worksheet = workbook.Sheets[sheetName];
        // const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

        // allSheets[sheetName] = jsonData;
        let sheetParsedData;

        if (sheetName === "Daily Work") {
          const raw = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
            defval: "",
          });

          sheetParsedData = {
            headerRow1: raw[0], // HR, HR Revenue, ERC...
            headerRow2: raw[1], // MOU, Non Mou
            body: raw.slice(2),
          };
        } else {
          sheetParsedData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
        }

        allSheets[sheetName] = sheetParsedData;

      });

      setSheetData(allSheets);

      message.success("All sheets loaded successfully");
    } catch (error) {
      console.error(error);
      message.error("Failed to load summary");
    }
  };



  return (
    <AdminDashboard>
      <div className="p-8 bg-blue-50 min-h-screen">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-3xl font-semibold text-gray-800">
            Summary Reports
          </h2>
          <div className="flex items-center">
            <span className="mr-4 text-gray-700">Filter by date</span>
            <RangePicker onChange={handleDateChange} className="bg-white" />
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md mb-4">
          <h3 className="text-xl font-medium text-gray-700 mb-4">Summary</h3>
          <Divider className="my-4" />

          {summaryItems.map((item) => (
            <Card key={item.id} className="mb-4 bg-gray-200 border-0">
              <div className="flex justify-between items-center">
                <div className="text-lg font-medium">{item.title}</div>

                <div>
                  <Button
                    className="bg-white text-gray-800 border border-gray-300 rounded-full mr-2"
                    onClick={() => generateAndView(item.id)}
                    type="primary"
                  >
                    View Document
                  </Button>
                  <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    onClick={() => generateAndDownload(item.id)}
                    className="bg-white text-gray-800 border border-gray-300 rounded-full "
                  >
                    Generate and download
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <AuditExport
          startDate={dateRange?.[0]?.format("YYYY-MM-DD")}
          endDate={dateRange?.[1]?.format("YYYY-MM-DD")}
        />



        {/* view the genrate document */}
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-medium text-gray-700 mb-4">
            View Summary
          </h3>

          {/* {Object.keys(sheetData).length === 0 ? (
            <p className="text-gray-500">No summary to display</p>
          ) : (
            Object.entries(sheetData).map(([sheetName, rows]) => {
              if (!rows.length) return null;

              const headers = Object.keys(rows[0]);

              return (
                <div key={sheetName} className="mb-8">
                  <h4 className="text-lg font-semibold text-blue-700 mb-3">
                    {sheetName}
                  </h4>

                  <div className="overflow-x-auto">
                    <table className="min-w-full border border-gray-300">
                      <thead className="bg-gray-100">
                        <tr>
                          {headers.map((header) => (
                            <th
                              key={header}
                              className="border px-3 py-2 text-left text-sm font-semibold"
                            >
                              {header}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {rows.map((row, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            {headers.map((header) => (
                              <td
                                key={header}
                                className="border px-3 py-2 text-sm"
                              >
                                {row[header]}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })
          )} */}

          {Object.entries(sheetData).map(([sheetName, data]) => {
            if (!data) return null;

            //  SPECIAL RENDER FOR DAILY WORK
            if (sheetName === "Daily Work") {
              const { headerRow1, headerRow2, body } = data;

              return (
                <div key={sheetName} className="mb-8">
                  <h4 className="text-lg font-semibold text-blue-700 mb-3">
                    {sheetName}
                  </h4>

                  <div className="overflow-x-auto">
                    <table className="min-w-full border border-gray-300 text-sm">
                      <thead>
                        {/*  HEADER ROW 1 */}
                        <tr className="bg-gray-200">
                          {headerRow1.map((cell, i) => {
                            if (!cell) return null;

                            const span =
                              headerRow1[i + 1] === "" ? 2 : 1;

                            return (
                              <th
                                key={i}
                                colSpan={span}
                                className="border px-3 py-2 text-center font-semibold"
                              >
                                {cell}
                              </th>
                            );
                          })}
                        </tr>

                        {/*  HEADER ROW 2 */}
                        <tr className="bg-gray-100">
                          {headerRow2.map((cell, i) => (
                            <th
                              key={i}
                              className={`border px-3 py-2 text-center font-semibold ${cell === "MOU"
                                ? "bg-blue-400 text-white"
                                : cell === "Non Mou"
                                  ? "bg-green-400 text-white"
                                  : ""
                                }`}
                            >
                              {cell}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {body.map((row, rIdx) => (
                          <tr key={rIdx} className="hover:bg-gray-50">
                            {row.map((cell, cIdx) => (
                              <td
                                key={cIdx}
                                className="border px-3 py-2 text-center"
                              >
                                {cell}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            }

            //  NORMAL TABLE FOR OTHER SHEETS
            const headers = Object.keys(data[0] || {});

            return (
              <div key={sheetName} className="mb-8">
                <h4 className="text-lg font-semibold text-blue-700 mb-3">
                  {sheetName}
                </h4>

                <div className="overflow-x-auto">
                  <table className="min-w-full border border-gray-300">
                    <thead className="bg-gray-100">
                      <tr>
                        {headers.map((h) => (
                          <th key={h} className="border px-3 py-2">
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {data.map((row, i) => (
                        <tr key={i}>
                          {headers.map((h) => (
                            <td key={h} className="border px-3 py-2">
                              {row[h]}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}

        </div>


      </div>
    </AdminDashboard>
  );
};

export default SummaryReports;
